import React, { useEffect, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { ImCross } from "react-icons/im";

const FoundOrder = ({
  allOrdersData,
  searchOrderIdInput,
  setSearchOrderIdInput,
  setInputValue,
  setIsShowShipping,
  setShippingData,
  ConfirmedOrder,
}) => {
  const [singleOrder, setSingleOrder] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const SingleOrder = allOrdersData.filter((single) => {
      return (
        single._id === searchOrderIdInput.trim() ||
        single.shippingDetails.name.toLowerCase().trim() ===
          searchOrderIdInput.toLowerCase().trim()
      );
    });
    setSingleOrder(SingleOrder);
    setLoading(false);
  }, [searchOrderIdInput]);
  const OnClickClose = () => {
    setSearchOrderIdInput("");
    setInputValue("");
  };
  console.log(singleOrder);
  return (
    <section className="foundOrder-popup">
      <article className="table-article-user">
        <div>
          <div style={{ position: "relative", height: "30px" }}>
            <button onClick={OnClickClose} className="pos-close-model-order">
              Close
            </button>
          </div>
          {loading ? (
            <h1>Single Order data is loading....</h1>
          ) : (
            <>
              {singleOrder.length === 0 ? (
                <h1 style={{ background: "black", padding: "3px 5px" }}>
                  No orders found by searching this order id or name
                </h1>
              ) : (
                <table
                  border="1"
                  style={{ fontWeight: "bolder", position: "relative" }}
                  className="foundOrder-table"
                >
                  <thead>
                    <tr style={{ background: "white", color: "black" }}>
                      <td>Order Time</td>
                      <td>Order ID</td>
                      <td>Name</td>
                      <td>Shipping Address</td>
                      <td>Total Price($)</td>
                      <td>Delivery Status</td>
                      <td>Delivery</td>
                    </tr>
                  </thead>
                  <tbody>
                    {singleOrder.map((single) => {
                      const {
                        _id: id,
                        createdAt,
                        isDelivered,
                        totalPrice,
                        userId,
                        shippingDetails: { name },
                      } = single;
                      const localDate = new Date(
                        createdAt
                      ).toLocaleDateString();
                      const localTime = new Date(
                        createdAt
                      ).toLocaleTimeString();
                      return (
                        <tr key={id} className="admin-item-list-table">
                          <td>
                            {localDate},{localTime}
                          </td>
                          <td>{id}</td>
                          <td>{name}</td>
                          <td>
                            <span
                              onClick={() => {
                                setShippingData(single.shippingDetails);
                                setIsShowShipping(true);
                              }}
                              className="orderShippingAddress"
                            >
                              CHECK
                            </span>
                          </td>
                          <td>{totalPrice}</td>
                          <td>
                            {isDelivered && isDelivered ? (
                              <span className="td-delivery-status deli-success found-search-order-td-deli-status">
                                <FaCheckCircle className="td-del-icon td-del-icon-order" />
                                Delivered
                              </span>
                            ) : (
                              <span className="td-delivery-status not-deli not-delivery-td">
                                <IoMdCloseCircleOutline className="td-del-icon" />
                                Not Delivered
                              </span>
                            )}
                          </td>
                          <td>
                            {isDelivered ? (
                              <span style={{ color: "white" }}>Confirmed</span>
                            ) : (
                              <p
                                onClick={() => ConfirmedOrder(id, userId)}
                                className="order-confirm-btn-td con-order-popup"
                              >
                                Confirm Now
                              </p>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </>
          )}
        </div>
      </article>
    </section>
  );
};

export default FoundOrder;
